import { SsoUserMergeDto, } from '@lucidlink/dto/web-service-api';
import { derivePasswordKey } from '@lucidlink/ts-crypto/crypto';
import { decryptAccountKey } from '#sdk/common/crypto';
import { prepareSsoUserCryptoWithExistingKey } from './prepare-user-crypto';
export const prepareSsoAccountMergeDto = async ({ domainSecret, password }, serverFinalMessage) => {
    const derivedKey = await derivePasswordKey(password, serverFinalMessage.userEncryptedKeyIterations, serverFinalMessage.userEncryptedKeySalt);
    const accountKey = await decryptAccountKey(serverFinalMessage.userEncryptedKey, derivedKey);
    const userCrypto = await prepareSsoUserCryptoWithExistingKey(domainSecret, accountKey);
    const ssoUserRequest = {
        userIdentity: {
            userCryptoKey: userCrypto.wrappedCryptoKeyB64,
            userCryptoKeySalt: userCrypto.salt,
        },
    };
    return SsoUserMergeDto.create(ssoUserRequest);
};
